/**
 * Created by shinan.chen on 2021/12/25.
 */
import { getCommon, postCommon } from '../tools';
import * as config from '../config';

export interface IAccount {
    id: number,
    username: string,
    password: string,
    admin: boolean,
    enable: boolean,
    lastLoginTime: Date,
    roles: string,
    stores: string,
}


export interface IAccountDetail {
    id: number,
    username: string,
    menus: IRolePermission[],
}

export const listAccounts = () =>
    getCommon({
        url: `${config.SERVICE_URL}/account/list_all`,
    });

export const createAccount = (data: IAccount) =>
    postCommon({
        url: `${config.SERVICE_URL}/account/create`,
        data
    });

export const updateAccount = (data: IAccount) =>
    postCommon({
        url: `${config.SERVICE_URL}/account/update`,
        data
    });

export const enableAccount = (id: number, enable: boolean) =>
    postCommon({
        url: `${config.SERVICE_URL}/account/enable?id=${id}&&enable=${enable}`
    });

export const getAccount = (id: any) =>
    getCommon({
        url: `${config.SERVICE_URL}/account/get?id=${id}`,
    });

export const deleteAccount = (id: number) =>
    postCommon({
        url: `${config.SERVICE_URL}/account/delete?id=${id}`
    });

export const pageAccounts = (pageNum: number, pageSize: number) =>
    getCommon({
        url: `${config.SERVICE_URL}/account/page?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });

export const loginAccount = (data: IAccount) =>
    postCommon({
        url: `${config.SERVICE_URL}/account/login`,
        data
    });

export interface IRolePermission {
    id: number,
    name: string,
    code: string,
    roleId: number,
    accountId: number,
    menuId: number,
    permissionId: number,
    type: string
}

export const listRoles = () =>
    getCommon({
        url: `${config.SERVICE_URL}/account/role/list_all`,
    });

export const listMenus = () =>
    getCommon({
        url: `${config.SERVICE_URL}/account/menu/list_all`,
    });

export const listPermissions = () =>
    getCommon({
        url: `${config.SERVICE_URL}/account/permission/list_all`,
    });

export const createRole = (data: IRolePermission) =>
    postCommon({
        url: `${config.SERVICE_URL}/account/role/create`,
        data
    });

export const updateRole = (data: IRolePermission) =>
    postCommon({
        url: `${config.SERVICE_URL}/account/role/update`,
        data
    });

export const deleteRole = (id: IRolePermission) =>
    postCommon({
        url: `${config.SERVICE_URL}/account/role/delete?id=${id}`
    });

export interface IOperateLog {
    id: number,
    name: string,
    url: string,
    request: string,
    response: string,
    costTime:number,

    creationTime: Date,
    createdBy: string,
}

export const pageOperateLogs = (pageNum: number, pageSize: number) =>
getCommon({
    url: `${config.SERVICE_URL}/account/log/page?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });

export const pageWechatLogs = (pageNum: number, pageSize: number) =>
getCommon({
    url: `${config.SERVICE_URL}/account/log/page_for_wx?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });

    export const pageWechatNoticeLogs = (pageNum: number, pageSize: number) =>
getCommon({
    url: `${config.SERVICE_URL}/account/log/page_for_wx_notice?pageNum=${pageNum}&&pageSize=${pageSize}`,
    });